import React, { useEffect, useState } from "react";
import useAvailableHeight from "../../Custom/UseAvailableHeight";
import cardimg from "../../../Assets/img/icons/icons8-bank-cards 1.svg";
import { useUserDetailContext } from "../../UserDetailContext";
import { getIconAndLabel } from "../../Utilities/SocialMediaMapping";
import ServiceImg from "../../../Assets/img/Homepage/Serviceitem.webp";
import BankOffer1 from "../../../Assets/img/Homepage/bankOffer1.svg";
import BankOffer2 from "../../../Assets/img/Homepage/bankOffer2.webp";
import BankOffer3 from "../../../Assets/img/Homepage/bankOffer3.svg";
import { Image, InsertInvitationRounded } from "@material-ui/icons";
import NoOfCards from "./NoOfCards";
import ToolsSection from "./ToolSection";
import ServiceSection from "./ServiceSection";
import Vcard from "../../../Assets/img/Homepage/Vcard.svg";
import Access from "../../../Assets/img/Homepage/ToolsAccess.svg";
import Payment from "../../../Assets/img/Homepage/Toolspayment.svg";
import ToolsCalendar from "../../../Assets/img/Homepage/ToolsConnection.svg";
import Event from "../../../Assets/img/Homepage/ToolsEvent.svg";
import TapGo from "../../../Assets/img/Homepage/Tap & Go.svg";
import Family from "../../../Assets/img/Homepage/ToolsFamily.svg";
import Health from "../../../Assets/img/Homepage/Health.svg";
import Calender from "../../../Assets/img/Homepage/calender.svg";
import Invite from "../../../Assets/img/Homepage/innvite.svg";
import Digital from "../../../Assets/img/Homepage/digital.svg";
import Others from "../../../Assets/img/Homepage/others.svg";
import Bill from "../../../Assets/img/Homepage/Bill.svg";
import KYC from "../../../Assets/img/Homepage/KYC.svg";
import CIBIL from "../../../Assets/img/Homepage/CIBILscore.svg";
import Manage from "../../../Assets/img/Homepage/Manage.svg";
import Reward from "../../../Assets/img/Homepage/Reward.svg";
import CreateCommunity from "../../../Assets/img/Homepage/createcommunity.svg";
import LiftStyle from "../../../Assets/img/Homepage/LiftStyle.svg";
import Discount from "../../../Assets/img/Homepage/discount.svg";
import Sku from "../../../Assets/img/Homepage/SKUoffers.svg";
import BeautyGroom from "../../../Assets/img/Homepage/BeautyGroom.svg";
import Notes from "../../../Assets/img/Homepage/Notes.svg";
import AccessManagement from "../../../Assets/img/Homepage/Set access role.svg";
import Subscription from "../../../Assets/img/Homepage/Subscription.svg";
import BirthChart from "../../../Assets/img/Homepage/BirthChart.svg";
import Travel from "../../../Assets/img/Homepage/Travell.svg";
import MemberShip from "../../../Assets/img/Homepage/MemberShipp.svg";
import PersonalService from "../../../Assets/img/Homepage/PersonalServicee.svg";
import Brand from "../../../Assets/img/Homepage/Brand.svg";
import Merchants from "../../../Assets/img/Homepage/Merchants.svg";
import Jobs from "../../../Assets/img/Homepage/Jobs.svg";
import Certificate from "../../../Assets/img/Homepage/Certificate.svg";
import ProfessionalService from "../../../Assets/img/Homepage/ProfessionalService.svg";
import Account from "../../../Assets/img/Homepage/Accounts.svg";
import Loans from "../../../Assets/img/Homepage/Loans.svg";
import Insurance from "../../../Assets/img/Homepage/Innsurance.svg";
import CreditCard from "../../../Assets/img/Homepage/CreditCard.svg";
import FD from "../../../Assets/img/Homepage/FD.svg";
import MutualFund from "../../../Assets/img/Homepage/MutulFunds.svg";
import RD from "../../../Assets/img/Homepage/RD.svg";
import PreApproved from "../../../Assets/img/Homepage/preApprovedLoan.svg";
import Paylater from "../../../Assets/img/Homepage/PayLater.svg";
import GiftCard from "../../../Assets/img/Homepage/GiftCard.svg";
import Advisory from "../../../Assets/img/Homepage/Advisory.svg";
import TravelCard from "../../../Assets/img/Homepage/serviceTravelCard.svg";
import GroupsIcon from "../../../Assets/img/Homepage/Group_icon.png";
import Recruit from "../../../Assets/img/Homepage/recruitment.png";
import Secure from "../../../Assets/Secure.svg";
import ComingSoons from "../../../Assets/ComingSoon.svg";
import Discounts from "../../../Assets/Discount.svg";
import Star from "../../../Assets/Star.svg";
import LifeStyle from "../../../Assets/LifeStyle.svg";
import TimeComingSoon from "../../../Assets/TimeComingSoon.svg";
import Community from "../../../Assets/Community.svg";
import university from "../../../Assets/img/Homepage/University-icon.svg";
import Schedule from "../../../Assets/img/Homepage/Schedule_icon.png";
import OffersSection from "./OfferSection";
import MapIntegration from "../Mapintegration";
import {
  Navigate,
  useLocation,
  useNavigate,
  useNavigation,
} from "react-router-dom";
import { InviteProfile } from "../MyProfileDetails/ProfileConnectionComponents";
import { useQuantityContext } from "../../QuantityContext";
import { Box, Drawer, IconButton, Modal, Typography } from "@material-ui/core";
import ProfessionalCalender from "../MyProfileDetails/SideFeedComponents/ProfessionalCalender";
import PersonalCalender from "../MyProfileDetails/PersonalCalender";
import { useDispatch } from "react-redux";
import {
  getAppliedJobs,
  getComapnyCalender,
  getJobAnalytics,
  getOpenJobs,
  setSelectedCompany,
} from "../../../Redux/Reducers/JobReducer";
import ComingSoon from "../../ComingSoon";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useSelector } from "react-redux";
import { Button } from "rsuite";
import { setExploreType } from "../../../Redux/Reducers/communityReducer";
import { getPersonalEvents, getProfessionalEvents } from "../../../Redux/Reducers/calendarReducer";
import ScheduleEvent from "../MyProfileDetails/SheduleEvent";
import { getPersonalityTestResult } from "../../../Redux/Reducers/numerologyReducer";
import SchedulePersonalEvent from "../MyProfileDetails/SideFeedComponents/SchedulePersonalEvent";
import { getConnectedReducer } from "../../../Redux/Reducers/ContactReducer";
import ProfessionalShedule from "../MyProfileDetails/ProfessionalShedule";
import { GetEnterpriseCompanyList, getUserIdDetails } from "../../../Redux/Reducers/OnboardingReducer";

const HomepageMiddleFeed = ({ activeMenu }) => {
  const dispatch = useDispatch();
  const [availableHeight1, Column1Ref] = useAvailableHeight(155);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [personalshowAll, setPersonalShowAll] = useState(false);
  const [professionashowAll, setProfessionalShowAll] = useState(false);
  const [financelshowAll, setFinancelShowAll] = useState(false);
  const [personalshowAllService, setPersonalShowAllService] = useState(false);
  const [professionalshowAllService, setProfessionalShowAllService] = useState(false);
  const [financialshowAllService, setFinancialShowAllService] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [openPersonalCalendar, setOpenPersonalCalendar] = useState(false);
  const [openAccessModal, setOpenAccessModal] = useState(false);
  const [currentModal, setCurrentModal] = useState(null);
  const { userDetails, cardDetailsAll, cardStylesAll, cards } = useUserDetailContext();
  const [scheduleDrawerOpen, setScheduleDrawerOpen] = useState(false);
  const [schedulePersonalOpen, setSchedulePersonalOpen] = useState(false);
  // console.log("userDetails---->", userDetails);
  const { handleCardClick } = useQuantityContext();
  const [showModal, setShowModal] = useState(false);
  const [CompanyModal, setCompanyModal] = useState(false);
  const { openSnackbar } = useQuantityContext();
  const Allcards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo) || [];
  const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
  const selectedCompany = useSelector((state) => state?.jobs?.selectedCompany) || {};
  const companies = useSelector((state) => state?.onboarding?.companies) || {};
  const currentExperiences = ProfessionalExperience?.filter(
    (exp) => exp.is_currently_working === true && exp.is_verified
  ) || [];

  const ProfessionalEducation = useSelector((state) => state?.ProfileArray?.educationData?.data) || [];
  const userTypeDetails = useSelector((state) => state?.onboarding?.userTypeDetails?.data) || [];

  console.log("userTypeDetailsMMMM", userTypeDetails);

  const currentEducation = ProfessionalEducation?.filter(
    (exp) => exp.is_pursuing === true && exp.is_verified
  ) || [];
  
  const filteredGroupCards = Allcards?.filter(
    (card) => card?.card_type === "group_family" && card?.card_email !== null
  );

  const FamilyId = filteredGroupCards?.map((card) => card?.group_id);
  let objectId = searchParams.get("objectId");
  
  const [ContactStyles, setContactStyles] = useState({
    User_ID: objectId,
    CardType: "Professional",
    iconBgColor: "#0044C6",
    callNo: { input: "", visible: true },
    textNo: { input: "", visible: true },
    emailId: { input: "", visible: true },
    whatsapp: { input: "", visible: true },
    address: "",
    city: "",
    postalcode: "",
    state: "",
    country: "",
    latitude: "",
    longtitude: "",
  });

  const { handleSuccess, handleFailure } = useQuantityContext();
  const [openInviteProfile, setOpenInviteProfile] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const lat = parseFloat(ContactStyles.latitude);
    const lon = parseFloat(ContactStyles.longtitude);

    if (!isNaN(lat) && !isNaN(lon)) {
      setLatitude(lat);
      setLongitude(lon);
    } else {
      setLatitude(12.979871024899435);
      setLongitude(77.60654611960474);
    }
  }, [ContactStyles.latitude, ContactStyles.longtitude]);

  useEffect(() => {
    return () => {
      setScheduleDrawerOpen(false);
      setSchedulePersonalOpen(false);
      setOpenCalendar(false);
      setOpenPersonalCalendar(false);
    };
  }, []);

  useEffect(() => {
    dispatch(getUserIdDetails(userDetails?.reference_id));
  }, [userDetails?.reference_id]);

  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedService, setSelectedService] = useState(null);

  const jobAnalytics = useSelector((state) => state?.jobs?.jobAnalytics) ?? {
    data: [],
    jobApplicationsStatuswiseCount: {},
    jobOpenCloseCount: {},
  };

  const analyticsCompanies = jobAnalytics?.companiesPostedByUser || [];

  // console.log("analyticsCompanies", analyticsCompanies, ProfessionalExperience)

  const matchedCompanies = analyticsCompanies?.length
    ? analyticsCompanies?.filter((jobCompany) => {
      return ProfessionalExperience?.some(
        (exp) =>
          exp?.company_name?.toLowerCase() ===
          jobCompany?.company_name?.toLowerCase() &&
          exp?.is_currently_working === true &&
          exp?.is_verified === true
      );
    })
    : ProfessionalExperience?.filter(
      (exp) => exp?.is_currently_working === true && exp?.is_verified === true
    ) || [];

    // console.log("matchedCompanies====", matchedCompanies)

  // ============ ENHANCED: getUserTypeAndLogo function with fallback logic ============
  const getUserTypeAndLogo = (userTypeDetails) => {
    // Check if we have data
    if (!userTypeDetails || userTypeDetails.length === 0) {
      return { 
        userType: null, 
        logo: null, 
        organizationName: null,
        roleName: null,
        allOrganizations: [],
        primaryOrg: null,
        hasUniversity: false,
        hasCompany: false,
        universityOrgs: [],
        companyOrgs: [],
        // Flag to indicate we have no data
        hasNoData: true,
        // Default fallback organizations
        defaultOrgs: [
          {
            organizationName: "University",
            organizationType: "university",
            roleName: "Student",
            organizationLogo: university,
            isDefault: true
          },
          {
            organizationName: "Company",
            organizationType: "company",
            roleName: "Employee",
            organizationLogo: Merchants,
            isDefault: true
          }
        ]
      };
    }

    const userData = userTypeDetails[0];

    if (!userData?.organizations || userData.organizations.length === 0) {
      return { 
        userType: null, 
        logo: null, 
        organizationName: null,
        roleName: null,
        allOrganizations: [],
        primaryOrg: null,
        hasUniversity: false,
        hasCompany: false,
        universityOrgs: [],
        companyOrgs: [],
        hasNoData: true,
        defaultOrgs: [
          {
            organizationName: "University",
            organizationType: "university",
            roleName: "Student",
            organizationLogo: university,
            isDefault: true
          },
          {
            organizationName: "Company",
            organizationType: "company",
            roleName: "Employee",
            organizationLogo: Merchants,
            isDefault: true
          }
        ]
      };
    }

    // Separate organizations by type
    const universityOrgs = userData.organizations.filter(org => org.organizationType === 'university');
    const companyOrgs = userData.organizations.filter(org => org.organizationType === 'company');

    // Determine if we have university or company
    const hasUniversity = universityOrgs.length > 0;
    const hasCompany = companyOrgs.length > 0;

    // Priority: Super Admin > Admin > HR Manager > Faculty > Employee > Alumni > Student
    const priorityOrder = {
      'Super Admin': 1,
      'Admin': 2,
      'HR Manager': 3,
      'Faculty': 4,
      'Employee': 5,
      'Alumni': 6,
      'Student': 7
    };

    let sortedOrgs = [...userData.organizations].sort((a, b) => {
      const priorityA = priorityOrder[a.roleName] || 999;
      const priorityB = priorityOrder[b.roleName] || 999;
      return priorityA - priorityB;
    });

    // ============ FALLBACK LOGIC ============
    // Case 1: If we have only university, add default company
    if (hasUniversity && !hasCompany) {
      sortedOrgs.push({
        organizationName: "Company",
        organizationType: "company",
        roleName: "Employee",
        organizationLogo: Merchants,
        isDefault: true
      });
    }
    // Case 2: If we have only company, add default university
    else if (!hasUniversity && hasCompany) {
      sortedOrgs.push({
        organizationName: "University",
        organizationType: "university",
        roleName: "Student",
        organizationLogo: university,
        isDefault: true
      });
    }
    // Case 3: If we have both, keep as is
    // Case 4: If we have neither (should not happen as we checked length > 0 above)

    const primaryOrg = sortedOrgs[0];

    let userType = null;

    // Determine user type based on primary organization
    const roleTypeMap = {
      'Super Admin': (org) => org.organizationType === 'university' ? 'university' : 'company',
      'Admin': (org) => org.organizationType === 'university' ? 'university' : 'company',
      'HR Manager': () => 'university',
      'Faculty': () => 'university',
      'Employee': () => 'company',
      'Alumni': () => 'university',
      'Student': () => 'university'
    };

    if (roleTypeMap[primaryOrg.roleName]) {
      userType = roleTypeMap[primaryOrg.roleName](primaryOrg);
    } else {
      userType = primaryOrg.organizationType;
    }

    return {
      userType: userType,
      logo: primaryOrg.organizationLogo,
      organizationName: primaryOrg.organizationName,
      roleName: primaryOrg.roleName,
      allOrganizations: sortedOrgs,
      primaryOrg: primaryOrg,
      hasUniversity: hasUniversity,
      hasCompany: hasCompany,
      universityOrgs: universityOrgs,
      companyOrgs: companyOrgs,
      hasNoData: false,
      defaultOrgs: []
    };
  };

  const userTypeInfo = getUserTypeAndLogo(userTypeDetails);
  // console.log('UserTypeInfo:', userTypeInfo);

  // ============ FUNCTION: Get user type for organization ============
  const getOrganizationUserType = (org) => {
    if (org.roleName === 'Super Admin' || org.roleName === 'Admin') {
      return org.organizationType === 'university' ? 'university' : 'company';
    } else if (['Faculty', 'Alumni', 'Student'].includes(org.roleName)) {
      return org.roleName;
    } else if (org.roleName === 'Employee' || org.roleName === 'HR Manager') {
      return 'company';
    }
    return org.organizationType;
  };

  // ============ FUNCTION: Handle organization click navigation ============
  const handleOrganizationClick = (org) => {
    const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
    let userType;
    
    // Check if this is a default organization
    if (org.isDefault) {
      // For default organizations, use their type directly
      userType = org.organizationType === 'university' ? 'university' : 'company';
    } else {
      userType = getOrganizationUserType(org);
    }
    
    console.log('Navigating to:', `${baseUrl}/?userType=${userType}`, 'for org:', org.organizationName);
    window.open(`${baseUrl}/?userType=${userType}`, '_blank');
  };

  // ============ FUNCTION: Get ALL organizations as service items ============
  const getOrganizationsAsServices = () => {
    const services = [];

    // Get organizations from userTypeInfo (which includes fallback defaults)
    const orgs = userTypeInfo.allOrganizations && userTypeInfo.allOrganizations.length > 0
      ? userTypeInfo.allOrganizations
      : userTypeInfo.defaultOrgs || [];

    // Add all organizations from the response
    orgs.forEach((org, index) => {
      // Determine the correct icon
      let icon = org.organizationLogo;
      let fallbackIcon = org.organizationType === 'company' ? Merchants : university;
      
      // If logo is null or undefined, use fallback
      if (!icon) {
        icon = fallbackIcon;
      }

      // Truncate organization name if too long
      let displayName = org.organizationName || `${org.roleName}`;
      if (displayName.length > 18) {
        displayName = displayName.substring(0, 16) + '...';
      }

      // Check if this is a default organization (added as fallback)
      const isDefault = org.isDefault || false;

      // Create a unique service item for this organization
      services.push({
        icon: icon,
        name: displayName,
        fullName: org.organizationName || `${org.roleName}`,
        roleName: org.roleName,
        organizationType: org.organizationType,
        organizationData: org,
        isDynamic: true,
        isOrganization: true,
        isDefault: isDefault,
        fallbackIcon: fallbackIcon,
        navUserType: isDefault ? org.organizationType : getOrganizationUserType(org),
        // Small icon style
        iconSize: '28px',
        fontSize: '8px'
      });
    });

    return services;
  };

  // ============ FUNCTION: Get dynamic service names with ALL organizations ============
  const getProfessionalServicesWithDynamicIcons = () => {
    // Start with base services that are always shown
    const baseServices = [
      { icon: CreateCommunity, name: "Social Ecosystem" },
      {
        icon: Certificate,
        name: "Certification",
        action: "/learningandcertifiate",
      },
      { icon: Brand, name: "Brands" },
      {
        icon: ProfessionalService,
        name: "Professional Service",
        action: "/myprofile?MainTab=professional_profile",
      },
      { icon: AccessManagement, name: "Access Management" },
      { icon: Subscription, name: "Subscription" },
      { icon: Event, name: "Events", action: "/professional-events" },
      { icon: Travel, name: "Travel" },
      { icon: MemberShip, name: "Membership" },
      { icon: Discount, name: "Discounts", action: "/discount" },
    ];

    // Get all organizations as service items
    const organizationServices = getOrganizationsAsServices();

    // Insert organization services at position 4 (after "Professional Service")
    const insertPosition = 4;
    
    if (organizationServices.length > 0) {
      // Remove existing "Company" and "University" entries if they exist
      const filteredBaseServices = baseServices.filter(
        item => item.name !== "Company" && item.name !== "University"
      );
      
      // Insert organization services
      filteredBaseServices.splice(insertPosition, 0, ...organizationServices);
      return filteredBaseServices;
    }

    return baseServices;
  };

  // ============ FUNCTION: Render organization logo ============
  const renderOrganizationLogo = () => {
    if (!userTypeInfo.logo) {
      return userTypeInfo.userType === 'company' 
        ? <img src={Merchants} alt="Company" style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'contain' }} />
        : <img src={university} alt="University" style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'contain' }} />;
    }

    return (
      <img 
        src={userTypeInfo.logo} 
        alt={userTypeInfo.organizationName || 'Organization'}
        style={{ 
          width: '40px', 
          height: '40px', 
          borderRadius: '8px',
          objectFit: 'contain'
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = userTypeInfo.userType === 'company' ? Merchants : university;
        }}
      />
    );
  };

  const handleRecruitClick = async () => {
    if (currentExperiences?.length === 0) {
      openSnackbar(
        "You need to be verified and currently employed to visit the posted jobs",
        "warning"
      );
      navigate("/myprofile?mainTab=professional_profile");
    } else {
      await dispatch(setSelectedCompany(matchedCompanies[0]?.company_name || {}));
      await dispatch(getAppliedJobs());
      await dispatch(getOpenJobs());
      const res = await dispatch(getJobAnalytics());
      if (res?.payload?.statusCode == 200) {
        navigate("/analytics-dashboard");
      }
    }
  };

  const handleQuickSheduleOpen = () => {
    const hasWorkExperience = currentExperiences && currentExperiences.length > 0;
    const hasEducation = currentEducation && currentEducation.length > 0;

    if (!hasWorkExperience && !hasEducation) {
      openSnackbar(
        "You need at least one verified working company or current education to schedule professional events. Please verify your profile to schedule events.",
        "warning"
      );
      navigate("/myprofile?mainTab=professional_profile");
    } else {
      setScheduleDrawerOpen(true);
    }
  };

  const handleScheduleClick = () => {
    setScheduleDrawerOpen(prev => !prev);
  };

  const handleClick = (index, type) => {
    setSelectedService(index);
    const cardTypes = {
      personal: personalcardName,
      professional: professionalcardName,
      financial: financelcardName,
    };
    handleCardClick("dashboard");

    const selectedCard = cardTypes[type]?.[index] || null;

    if (selectedCard.name === "Invite") {
      setOpenInviteProfile(true);
      return;
    } else if (selectedCard.name === "Calender") {
      setOpenCalendar(true);
      dispatch(getProfessionalEvents());
      return;
    } else if (selectedCard.name === "Calendar") {
      dispatch(getPersonalEvents());
      dispatch(getConnectedReducer());
      setOpenPersonalCalendar(true);
      return;
    } else if (selectedCard.name === "Scheduler") {
      setSchedulePersonalOpen(true);
      return;
    } else if (selectedCard.name === "Schedule") {
      handleQuickSheduleOpen();
      return;
    } else if (selectedCard.name === "Access") {
      setOpenAccessModal(true);
      return;
    } else if (selectedCard.name == "Events") {
      dispatch(getPersonalEvents());
      navigate('/personal-events');
      return;
    } else if (selectedCard.name === "Family") {
      if (Array.isArray(FamilyId) && FamilyId?.length > 0) {
        navigate(selectedCard.action);
      } else {
        setShowModal(true);
      }
      return;
    } else if (selectedCard?.action) {
      if (selectedCard.name === "Recruit") {
        handleRecruitClick();
        return;
      }
      dispatch(getJobAnalytics());
      dispatch(getAppliedJobs());
      dispatch(getOpenJobs());
      navigate(selectedCard.action);
      return;
    }

    if (selectedCard) {
      switch (selectedCard.name) {
        case "Events":
          setCurrentModal({ type: "Events", image: Star });
          break;
        case "Access":
          setCurrentModal({ type: "Access", image: Secure });
          break;
        case "CIBIL Score":
          setCurrentModal({ type: "cibil", image: Secure });
          break;
        default:
          setCurrentModal(null);
      }
    }
  };

  // ============ UPDATED: handlServiceClick with organization handling ============
  const handlServiceClick = (index, type) => {
    setSelectedService(index);
    const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
    
    // Get the service names based on type
    let serviceNames;
    if (type === 'professional') {
      serviceNames = getProfessionalServicesWithDynamicIcons();
    } else if (type === 'personal') {
      serviceNames = personalServiceName;
    } else if (type === 'financial') {
      serviceNames = financelServiceName;
    } else {
      serviceNames = [];
    }

    const selectedServicesCard = serviceNames[index];
    console.log('Selected Service:', selectedServicesCard);

    // Check if this is an organization card
    if (selectedServicesCard?.isOrganization) {
      const org = selectedServicesCard.organizationData;
      if (org) {
        console.log('Organization clicked:', org);
        handleOrganizationClick(org);
        return;
      }
    }

    // Check for Social Ecosystem
    if (selectedServicesCard?.name === "Social Ecosystem") {
      if (type === "personal") {
        dispatch(setExploreType("PERSONAL"));
        navigate("/community");
        return;
      } else if (type === "professional") {
        const hasVerifiedEducation = ProfessionalEducation?.some(
          edu => edu.is_verified === true
        );
        const hasVerifiedCurrentWork = currentExperiences?.length > 0;

        if (hasVerifiedEducation || hasVerifiedCurrentWork) {
          dispatch(setExploreType("PROFESSIONAL"));
          navigate("/community");
        } else {
          openSnackbar(
            "Verify at least one education or company to access the professional community.",
            "warning"
          );
        }
        return;
      }
    }

    // Handle navigation for actions
    if (selectedServicesCard?.action) {
      navigate(selectedServicesCard?.action);
      return;
    }

    // Handle other service clicks
    if (selectedServicesCard) {
      switch (selectedServicesCard.name) {
        case "Payments":
          setCurrentModal({ type: "Payments", image: Star });
          break;
        case "Beauty Grooming":
          setCurrentModal({ type: "Beauty Grooming", image: Star });
          break;
        case "Create Community":
          setCurrentModal({ type: "Create Community", image: Star });
          break;
        case "Life cycle":
          setCurrentModal({ type: "Life style", image: Star });
          break;
        case "Access Management":
          setCurrentModal({ type: "Access Management", image: Secure });
          break;
        case "SKU & Offers":
          setCurrentModal({ type: "SKU & Offers", image: Star });
          break;
        case "Subscription":
          setCurrentModal({ type: "Subscription", image: Star });
          break;
        case "Birth Chart":
          setCurrentModal({ type: "Birth Chart", image: Star });
          break;
        case "Travel":
          setCurrentModal({ type: "Travel", image: Star });
          break;
        case "Membership":
          setCurrentModal({ type: "Membership", image: Star });
          break;
        case "Personality Test":
          dispatch(getPersonalityTestResult());
          navigate("/personalitytest");
          break;
        case "Brands":
          setCurrentModal({ type: "Brands", image: Star });
          break;
        case "Events":
          dispatch(getProfessionalEvents());
          navigate('/professional-events');
          break;
        case "Discounts":
          setCurrentModal({ type: "Discounts", image: Star });
          break;
        default:
          setCurrentModal(null);
      }
    }
  };

  const [showOrganizationSelector, setShowOrganizationSelector] = useState(false);

  const personalcardName = [
    { icon: Access, name: "Access" },
    { icon: Event, name: "Events", action: "/personal-events" },
    { icon: Calender, name: "Calendar" },
    { icon: Schedule, name: "Scheduler" },
    { icon: Notes, name: "Notes", action: "/notes" },
    { icon: GroupsIcon, name: "Group", action: "/AllGroup_details" },
    { icon: Family, name: "Family", action: `/familyCard/${FamilyId?.[0]}` },
    { icon: Family, name: "CCE", action: `/connect-chat` },
  ];

  const professionalcardName = [
    { icon: Vcard, name: "V Card", action: "/AllBusinessCard" },
    { icon: Access, name: "Access" },
    { icon: Calender, name: "Calender" },
    { icon: Schedule, name: "Schedule" },
    { icon: Notes, name: "Notes", action: "/notes" },
    { icon: Invite, name: "Invite" },
    { icon: Jobs, name: "Jobs", action: "/jobopening" },
    { icon: Recruit, name: "Recruit", action: "/analytics-dashboard" },
  ];

  const financelcardName = [
    { icon: Payment, name: "Scan & Pay" },
    { icon: TapGo, name: "Tap & Go" },
    { icon: Bill, name: "Bills" },
    { icon: Event, name: "Events" },
    { icon: KYC, name: "KYC", action: "/countrySelecting" },
    { icon: CIBIL, name: "CIBIL Score" },
    { icon: Manage, name: "Manage" },
    { icon: Reward, name: "Reward" },
  ];

  const personalServiceName = [
    { icon: CreateCommunity, name: "Social Ecosystem", action: "/community" },
    { icon: PersonalService, name: "Personality Test", action: "/personalitytest" },
    { icon: BirthChart, name: "Birth Chart" },
    { icon: LiftStyle, name: "Life Style", action: "/product-marketplace" },
    { icon: BeautyGroom, name: "Beauty Grooming" },
    { icon: Discount, name: "Discounts", action: "/discount" },
    { icon: Sku, name: "SKU & Offers" },
    { icon: Travel, name: "Travel" },
    { icon: Subscription, name: "Subscription" },
    { icon: Payment, name: "Payments" },
    { icon: AccessManagement, name: "Access Management" },
    { icon: MemberShip, name: "Membership" },
  ];

  // Base professional services (without organization items)
  const professionalServiceName = [
    { icon: CreateCommunity, name: "Social Ecosystem" },
    {
      icon: Certificate,
      name: "Certification",
      action: "/learningandcertifiate",
    },
    { icon: Brand, name: "Brands" },
    {
      icon: ProfessionalService,
      name: "Professional Service",
      action: "/myprofile?MainTab=professional_profile",
    },
    { icon: AccessManagement, name: "Access Management" },
    { icon: Subscription, name: "Subscription" },
    { icon: Event, name: "Events", action: "/professional-events" },
    { icon: Travel, name: "Travel" },
    { icon: MemberShip, name: "Membership" },
    { icon: Discount, name: "Discounts", action: "/discount" },
  ];

  const financelServiceName = [
    { icon: Account, name: "Accounts" },
    { icon: Loans, name: "Loans" },
    { icon: Insurance, name: "Insurance" },
    { icon: CreditCard, name: "Credit Card" },
    { icon: FD, name: "FD" },
    { icon: MutualFund, name: "Mutual Funds" },
    { icon: RD, name: "RD" },
    { icon: PreApproved, name: "Pre-approved Loans" },
    { icon: Paylater, name: "Pay Later" },
    { icon: GiftCard, name: "Gift Cards" },
    { icon: Advisory, name: "Advisory" },
    { icon: TravelCard, name: "Travel Card" },
  ];

  const financialoffers = [
    { image: BankOffer1, alt: "Bank Offer 1" },
    { image: BankOffer2, alt: "Bank Offer 2" },
    { image: BankOffer3, alt: "Bank Offer 3" },
  ];

  const personaloffers = [{ image: ServiceImg, alt: "offers" }];

  return (
    <>
      <NoOfCards />
      
      {activeMenu === "personal_profile" ? (
        <ToolsSection
          showAll={personalshowAll}
          toggleView={() => setPersonalShowAll(!personalshowAll)}
          cardData={personalcardName}
          handleCardClick={handleClick}
          type={"personal"}
        />
      ) : activeMenu === "professional_profile" ? (
        <ToolsSection
          showAll={professionashowAll}
          toggleView={() => setProfessionalShowAll(!professionashowAll)}
          cardData={professionalcardName}
          handleCardClick={handleClick}
          type={"professional"}
        />
      ) : activeMenu === "financel" ? (
        <ToolsSection
          showAll={financelshowAll}
          toggleView={() => setFinancelShowAll(!financelshowAll)}
          cardData={financelcardName}
          handleCardClick={handleClick}
          type={"financial"}
        />
      ) : null}

      {activeMenu === "personal_profile" ? (
        <ServiceSection
          serviceNames={personalServiceName}
          showAll={personalshowAllService}
          toggleView={() => setPersonalShowAllService(!personalshowAllService)}
          handleClick={handlServiceClick}
          type={"personal"}
        />
      ) : activeMenu === "professional_profile" ? (
        <ServiceSection
          serviceNames={getProfessionalServicesWithDynamicIcons()}
          showAll={professionalshowAllService}
          toggleView={() => setProfessionalShowAllService(!professionalshowAllService)}
          handleClick={handlServiceClick}
          type={"professional"}
        />
      ) : activeMenu === "financel" ? (
        <ServiceSection
          serviceNames={financelServiceName}
          showAll={financialshowAllService}
          toggleView={() => setFinancialShowAllService(!financialshowAllService)}
          handleClick={handlServiceClick}
          type={"financial"}
        />
      ) : null}

      {activeMenu === "financel" ? (
        <OffersSection offers={financialoffers} />
      ) : (
        <OffersSection offers={personaloffers} />
      )}

      <div
        className="home-sec-middlePart p-2 "
        style={{
          scrollbarWidth: "none",
        }}
      >
        {latitude !== null &&
          latitude !== "" &&
          longitude !== null &&
          longitude !== "" && (
            <div
              style={{
                width: "420px",
                height: "300px",
                minWidth: "380px",
                maxWidth: "420px",
              }}
            >
              <MapIntegration
                style={{ borderRadius: "6px" }}
                latitude={latitude}
                longitude={longitude}
              />
            </div>
          )}

        {/* ============ Display Organization Logo Section ============ */}
        {userTypeInfo.organizationName && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 16px',
            background: '#f8f9fa',
            borderRadius: '8px',
            marginBottom: '16px',
            border: '1px solid #e9ecef'
          }}>
            {renderOrganizationLogo()}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
                {userTypeInfo.organizationName}
                {userTypeInfo.primaryOrg?.isDefault && (
                  <span style={{ 
                    fontSize: '10px', 
                    color: '#999', 
                    marginLeft: '8px',
                    fontStyle: 'italic',
                    background: '#f0f0f0',
                    padding: '1px 8px',
                    borderRadius: '4px'
                  }}>
                    (Default)
                  </span>
                )}
              </span>
              <span style={{ fontSize: '12px', color: '#666' }}>
                {userTypeInfo.roleName} • {userTypeInfo.userType === 'company' ? '🏢 Company' : '🎓 University'}
                {userTypeInfo.hasNoData && (
                  <span style={{ 
                    marginLeft: '8px', 
                    fontSize: '11px', 
                    color: '#ff6b35',
                    fontWeight: 500
                  }}>
                    • No organization data found
                  </span>
                )}
              </span>
            </div>
          </div>
        )}

        <Drawer
          anchor="right"
          open={openCalendar}
          onClose={() => {
            setOpenCalendar(false);
            setSelectedEvent(null);
          }}
          classes={{
            paper: {
              width: "90vw",
              maxWidth: "50vw",
            },
          }}
        >
          <Box
            sx={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              p: "20px",
            }}
          >
            <Box
              display="flex"
              justifyContent="flex-start"
              mb={2}
              sx={{ width: "100%" }}
            >
              <IconButton onClick={() => setOpenCalendar(false)}>
                <CloseRoundedIcon />
              </IconButton>
            </Box>
            <Box sx={{ flex: 1, overflow: "hidden", padding: "20px" }}>
              <ProfessionalCalender initialView="month" />
            </Box>
          </Box>
        </Drawer>

        <Drawer
          anchor="right"
          open={openPersonalCalendar}
          onClose={() => {
            setOpenPersonalCalendar(false);
            setSelectedEvent(null);
          }}
          classes={{
            paper: {
              width: "90vw",
              maxWidth: "50vw",
            },
          }}
        >
          <Box
            sx={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              p: "20px",
            }}
          >
            <Box
              display="flex"
              justifyContent="flex-start"
              mb={2}
              sx={{ width: "100%" }}
            >
              <IconButton onClick={() => setOpenPersonalCalendar(false)}>
                <CloseRoundedIcon />
              </IconButton>
            </Box>
            <Box sx={{ flex: 1, overflow: "hidden", padding: "20px" }}>
              <PersonalCalender />
            </Box>
          </Box>
        </Drawer>

        <Modal
          open={Boolean(CompanyModal)}
          onClose={() => setCompanyModal(false)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "32px",
              maxWidth: "450px",
              width: "90%",
              boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
              outline: "none",
              position: "relative",
            }}
          >
            <IconButton
              onClick={() => setCompanyModal(false)}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                color: "#666"
              }}
            >
              <CloseRoundedIcon />
            </IconButton>

            <Box style={{ textAlign: "center", padding: "16px 0" }}>
              <Typography variant="h6" style={{
                fontWeight: 600,
                color: "#333",
                marginBottom: "16px"
              }}>
                Create Your Company
              </Typography>
              <Typography variant="body2" style={{
                color: "#666",
                marginBottom: "24px",
                lineHeight: 1.5
              }}>
                To access company features, you need to create or register your company first
              </Typography>

              <Box style={{
                display: "flex",
                gap: "16px",
                justifyContent: "center",
                marginTop: "32px"
              }}>
                <Button
                  variant="outlined"
                  onClick={() => setCompanyModal(false)}
                  style={{
                    borderColor: "#ddd",
                    color: "#666",
                    textTransform: "none",
                    padding: "8px 24px"
                  }}
                >
                  Maybe Later
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
                    setCompanyModal(false);
                    window.location.replace(`${baseUrl}`);
                  }}
                  style={{
                    backgroundColor: "#0044C6",
                    color: "white",
                    textTransform: "none",
                    borderRadius: "5px",
                    padding: "8px 32px"
                  }}
                >
                  Create Company
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={Boolean(currentModal)}
          onClose={() => setCurrentModal(null)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "background.paper",
              borderRadius: 2,
              p: 2,
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflow: "auto",
              outline: "none",
              position: "relative",
            }}
          >
            {currentModal && (
              <ComingSoon
                imageSrc={currentModal?.image}
                onClose={() => setCurrentModal(null)}
              />
            )}
          </Box>
        </Modal>

        <Modal
          open={showOrganizationSelector}
          onClose={() => setShowOrganizationSelector(false)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "24px",
              maxWidth: "500px",
              width: "90%",
              maxHeight: "80vh",
              overflow: "auto",
              outline: "none",
            }}
          >
            <Typography variant="h6" style={{ marginBottom: '16px', fontWeight: 600 }}>
              Select Organization
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {userTypeInfo.allOrganizations?.map((org, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    handleOrganizationClick(org);
                    setShowOrganizationSelector(false);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px 16px',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    transition: 'background 0.2s',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = '#f8f9fa'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                >
                  {org.organizationLogo ? (
                    <img 
                      src={org.organizationLogo} 
                      alt={org.organizationName}
                      style={{ width: '40px', height: '40px', borderRadius: '6px', objectFit: 'contain' }}
                    />
                  ) : (
                    <div style={{ 
                      width: '40px', 
                      height: '40px', 
                      borderRadius: '6px',
                      background: org.organizationType === 'company' ? '#e3f2fd' : '#f3e5f5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      color: org.organizationType === 'company' ? '#1976d2' : '#7b1fa2'
                    }}>
                      {org.organizationName?.charAt(0) || org.roleName?.charAt(0) || '?'}
                    </div>
                  )}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 500, fontSize: '14px' }}>
                      {org.organizationName || 'Unnamed Organization'}
                      {org.isDefault && (
                        <span style={{ 
                          fontSize: '10px', 
                          color: '#999', 
                          marginLeft: '8px',
                          fontStyle: 'italic',
                          background: '#f0f0f0',
                          padding: '1px 8px',
                          borderRadius: '4px'
                        }}>
                          (Default)
                        </span>
                      )}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666', display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <span style={{ 
                        color: org.organizationType === 'company' ? '#1976d2' : '#7b1fa2',
                        fontWeight: 500
                      }}>
                        {org.roleName}
                      </span>
                      <span style={{ color: '#999' }}>
                        {org.organizationType === 'university' ? '🎓' : '💼'}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <Button 
              onClick={() => setShowOrganizationSelector(false)}
              style={{ marginTop: '16px', width: '100%' }}
            >
              Cancel
            </Button>
          </Box>
        </Modal>

        {showModal && (
          <div className="lightbox-overlay">
            <div className="lightbox-content p-4">
              <div className="d-flex align-items-center justify-content-between">
                <h6
                  className="mb-0"
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Family card
                </h6>
                <IconButton onClick={() => setShowModal(false)}>
                  <CloseRoundedIcon />
                </IconButton>
              </div>
              <Typography variant="body2" className="text-muted">
                You haven't created your Family Card yet. Please create your
                Family Card to view it here.
              </Typography>
            </div>
          </div>
        )}

        <InviteProfile
          open={openInviteProfile}
          setModalOpen={setOpenInviteProfile}
          handleSuccess={handleSuccess}
          handleFailure={handleFailure}
        />

        <ProfessionalShedule
          open={scheduleDrawerOpen}
          onClose={() => {
            setScheduleDrawerOpen(false);
          }}
        />

        <ScheduleEvent
          open={scheduleDrawerOpen}
          onClose={() => {
            setScheduleDrawerOpen(false);
          }}
        />

        <SchedulePersonalEvent
          open={schedulePersonalOpen}
          onClose={() => {
            setSchedulePersonalOpen(false);
            dispatch(getPersonalEvents());
          }}
        />
      </div>
    </>
  );
};

export default HomepageMiddleFeed;

// import React, { useEffect, useState } from "react";
// import useAvailableHeight from "../../Custom/UseAvailableHeight";
// import cardimg from "../../../Assets/img/icons/icons8-bank-cards 1.svg";
// import { useUserDetailContext } from "../../UserDetailContext";
// import { getIconAndLabel } from "../../Utilities/SocialMediaMapping";
// import ServiceImg from "../../../Assets/img/Homepage/Serviceitem.webp";
// import BankOffer1 from "../../../Assets/img/Homepage/bankOffer1.svg";
// import BankOffer2 from "../../../Assets/img/Homepage/bankOffer2.webp";
// import BankOffer3 from "../../../Assets/img/Homepage/bankOffer3.svg";
// import { Image, InsertInvitationRounded } from "@material-ui/icons";
// import NoOfCards from "./NoOfCards";
// import ToolsSection from "./ToolSection";
// import ServiceSection from "./ServiceSection";
// import Vcard from "../../../Assets/img/Homepage/Vcard.svg";
// import Access from "../../../Assets/img/Homepage/ToolsAccess.svg";
// import Payment from "../../../Assets/img/Homepage/Toolspayment.svg";
// import ToolsCalendar from "../../../Assets/img/Homepage/ToolsConnection.svg";
// import Event from "../../../Assets/img/Homepage/ToolsEvent.svg";
// import TapGo from "../../../Assets/img/Homepage/Tap & Go.svg";
// import Family from "../../../Assets/img/Homepage/ToolsFamily.svg";
// import Health from "../../../Assets/img/Homepage/Health.svg";
// import Calender from "../../../Assets/img/Homepage/calender.svg";
// import Invite from "../../../Assets/img/Homepage/innvite.svg";
// import Digital from "../../../Assets/img/Homepage/digital.svg";
// import Others from "../../../Assets/img/Homepage/others.svg";
// import Bill from "../../../Assets/img/Homepage/Bill.svg";
// import KYC from "../../../Assets/img/Homepage/KYC.svg";
// import CIBIL from "../../../Assets/img/Homepage/CIBILscore.svg";
// import Manage from "../../../Assets/img/Homepage/Manage.svg";
// import Reward from "../../../Assets/img/Homepage/Reward.svg";
// import CreateCommunity from "../../../Assets/img/Homepage/createcommunity.svg";
// import LiftStyle from "../../../Assets/img/Homepage/LiftStyle.svg";
// import Discount from "../../../Assets/img/Homepage/discount.svg";
// import Sku from "../../../Assets/img/Homepage/SKUoffers.svg";
// import BeautyGroom from "../../../Assets/img/Homepage/BeautyGroom.svg";
// import Notes from "../../../Assets/img/Homepage/Notes.svg";
// import AccessManagement from "../../../Assets/img/Homepage/Set access role.svg";
// import Subscription from "../../../Assets/img/Homepage/Subscription.svg";
// import BirthChart from "../../../Assets/img/Homepage/BirthChart.svg";
// import Travel from "../../../Assets/img/Homepage/Travell.svg";
// import MemberShip from "../../../Assets/img/Homepage/MemberShipp.svg";
// import PersonalService from "../../../Assets/img/Homepage/PersonalServicee.svg";
// import Brand from "../../../Assets/img/Homepage/Brand.svg";
// import Merchants from "../../../Assets/img/Homepage/Merchants.svg";
// import Jobs from "../../../Assets/img/Homepage/Jobs.svg";
// import Certificate from "../../../Assets/img/Homepage/Certificate.svg";
// import ProfessionalService from "../../../Assets/img/Homepage/ProfessionalService.svg";
// import Account from "../../../Assets/img/Homepage/Accounts.svg";
// import Loans from "../../../Assets/img/Homepage/Loans.svg";
// import Insurance from "../../../Assets/img/Homepage/Innsurance.svg";
// import CreditCard from "../../../Assets/img/Homepage/CreditCard.svg";
// import FD from "../../../Assets/img/Homepage/FD.svg";
// import MutualFund from "../../../Assets/img/Homepage/MutulFunds.svg";
// import RD from "../../../Assets/img/Homepage/RD.svg";
// import PreApproved from "../../../Assets/img/Homepage/preApprovedLoan.svg";
// import Paylater from "../../../Assets/img/Homepage/PayLater.svg";
// import GiftCard from "../../../Assets/img/Homepage/GiftCard.svg";
// import Advisory from "../../../Assets/img/Homepage/Advisory.svg";
// import TravelCard from "../../../Assets/img/Homepage/serviceTravelCard.svg";
// import GroupsIcon from "../../../Assets/img/Homepage/Group_icon.png";
// import Recruit from "../../../Assets/img/Homepage/recruitment.png";
// import Secure from "../../../Assets/Secure.svg";
// import ComingSoons from "../../../Assets/ComingSoon.svg";
// import Discounts from "../../../Assets/Discount.svg";
// import Star from "../../../Assets/Star.svg";
// import LifeStyle from "../../../Assets/LifeStyle.svg";
// import TimeComingSoon from "../../../Assets/TimeComingSoon.svg";
// import Community from "../../../Assets/Community.svg";
// import university from "../../../Assets/img/Homepage/University-icon.svg";
// import Schedule from "../../../Assets/img/Homepage/Schedule_icon.png";
// import OffersSection from "./OfferSection";
// import MapIntegration from "../Mapintegration";
// import {
//   Navigate,
//   useLocation,
//   useNavigate,
//   useNavigation,
// } from "react-router-dom";
// import { InviteProfile } from "../MyProfileDetails/ProfileConnectionComponents";
// import { useQuantityContext } from "../../QuantityContext";
// import { Box, Drawer, IconButton, Modal, Typography } from "@material-ui/core";
// import ProfessionalCalender from "../MyProfileDetails/SideFeedComponents/ProfessionalCalender";
// import PersonalCalender from "../MyProfileDetails/PersonalCalender";
// import { useDispatch } from "react-redux";
// import {
//   getAppliedJobs,
//   getComapnyCalender,
//   getJobAnalytics,
//   getOpenJobs,
//   getUserEvents,
//   setSelectedCompany,
// } from "../../../Redux/Reducers/JobReducer";
// import ComingSoon from "../../ComingSoon";
// import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
// import { useSelector } from "react-redux";
// import { Button } from "rsuite";
// import { setExploreType } from "../../../Redux/Reducers/communityReducer";
// import { getPersonalEvents, getProfessionalEvents } from "../../../Redux/Reducers/calendarReducer";
// import ScheduleEvent from "../MyProfileDetails/SheduleEvent";
// import { getPersonalityTestResult } from "../../../Redux/Reducers/numerologyReducer";
// import SchedulePersonalEvent from "../MyProfileDetails/SideFeedComponents/SchedulePersonalEvent";
// import { getConnectedReducer } from "../../../Redux/Reducers/ContactReducer";
// import ProfessionalShedule from "../MyProfileDetails/ProfessionalShedule";
// import { GetEnterpriseCompanyList, getUserIdDetails } from "../../../Redux/Reducers/OnboardingReducer";

// const HomepageMiddleFeed = ({ activeMenu }) => {
//   const dispatch = useDispatch();
//   const [availableHeight1, Column1Ref] = useAvailableHeight(155);
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [personalshowAll, setPersonalShowAll] = useState(false);
//   const [professionashowAll, setProfessionalShowAll] = useState(false);
//   const [financelshowAll, setFinancelShowAll] = useState(false);
//   const [personalshowAllService, setPersonalShowAllService] = useState(false);
//   const [professionalshowAllService, setProfessionalShowAllService] = useState(false);
//   const [financialshowAllService, setFinancialShowAllService] = useState(false);
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const [openCalendar, setOpenCalendar] = useState(false);
//   const [openPersonalCalendar, setOpenPersonalCalendar] = useState(false);
//   const [openAccessModal, setOpenAccessModal] = useState(false);
//   const [currentModal, setCurrentModal] = useState(null);
//   const { userDetails, cardDetailsAll, cardStylesAll, cards } = useUserDetailContext();
//   const [scheduleDrawerOpen, setScheduleDrawerOpen] = useState(false);
//   const [schedulePersonalOpen, setSchedulePersonalOpen] = useState(false);
//   console.log("userDetails---->", userDetails);
//   const { handleCardClick } = useQuantityContext();
//   const [showModal, setShowModal] = useState(false);
//   const [CompanyModal, setCompanyModal] = useState(false);
//   const { openSnackbar } = useQuantityContext();
//   const Allcards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo) || [];
//   const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];
//   const selectedCompany = useSelector((state) => state?.jobs?.selectedCompany) || {};
//   const companies = useSelector((state) => state?.onboarding?.companies) || {};
//   const currentExperiences = ProfessionalExperience?.filter(
//     (exp) => exp.is_currently_working === true && exp.is_verified
//   ) || [];

//   const ProfessionalEducation = useSelector((state) => state?.ProfileArray?.educationData?.data) || [];
//   const userTypeDetails = useSelector((state) => state?.onboarding?.userTypeDetails?.data) || [];

//   console.log("userTypeDetailsMMMM", userTypeDetails);

//   const currentEducation = ProfessionalEducation?.filter(
//     (exp) => exp.is_pursuing === true && exp.is_verified
//   ) || [];
  
//   const filteredGroupCards = Allcards?.filter(
//     (card) => card?.card_type === "group_family" && card?.card_email !== null
//   );

//   const FamilyId = filteredGroupCards?.map((card) => card?.group_id);
//   let objectId = searchParams.get("objectId");
  
//   const [ContactStyles, setContactStyles] = useState({
//     User_ID: objectId,
//     CardType: "Professional",
//     iconBgColor: "#0044C6",
//     callNo: { input: "", visible: true },
//     textNo: { input: "", visible: true },
//     emailId: { input: "", visible: true },
//     whatsapp: { input: "", visible: true },
//     address: "",
//     city: "",
//     postalcode: "",
//     state: "",
//     country: "",
//     latitude: "",
//     longtitude: "",
//   });

//   const { handleSuccess, handleFailure } = useQuantityContext();
//   const [openInviteProfile, setOpenInviteProfile] = useState(false);
//   const [latitude, setLatitude] = useState("");
//   const [longitude, setLongitude] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const lat = parseFloat(ContactStyles.latitude);
//     const lon = parseFloat(ContactStyles.longtitude);

//     if (!isNaN(lat) && !isNaN(lon)) {
//       setLatitude(lat);
//       setLongitude(lon);
//     } else {
//       setLatitude(12.979871024899435);
//       setLongitude(77.60654611960474);
//     }
//   }, [ContactStyles.latitude, ContactStyles.longtitude]);

//   useEffect(() => {
//     return () => {
//       setScheduleDrawerOpen(false);
//       setSchedulePersonalOpen(false);
//       setOpenCalendar(false);
//       setOpenPersonalCalendar(false);
//     };
//   }, []);

//   useEffect(() => {
//     dispatch(getUserIdDetails(userDetails?.reference_id));
//   }, [userDetails?.reference_id]);

//   const [selectedCard, setSelectedCard] = useState(null);
//   const [selectedService, setSelectedService] = useState(null);

//   const jobAnalytics = useSelector((state) => state?.jobs?.jobAnalytics) ?? {
//     data: [],
//     jobApplicationsStatuswiseCount: {},
//     jobOpenCloseCount: {},
//   };

//   const analyticsCompanies = jobAnalytics?.companiesPostedByUser || [];

//   const matchedCompanies = analyticsCompanies?.length
//     ? analyticsCompanies?.filter((jobCompany) => {
//       return ProfessionalExperience?.some(
//         (exp) =>
//           exp?.company_name?.toLowerCase() ===
//           jobCompany?.company_name?.toLowerCase() &&
//           exp?.is_currently_working === true &&
//           exp?.is_verified === true
//       );
//     })
//     : ProfessionalExperience?.filter(
//       (exp) => exp?.is_currently_working === true && exp?.is_verified === true
//     ) || [];

//   // ============ ENHANCED: getUserTypeAndLogo function ============
//   const getUserTypeAndLogo = (userTypeDetails) => {
//     if (!userTypeDetails || userTypeDetails.length === 0) {
//       return { 
//         userType: null, 
//         logo: null, 
//         organizationName: null,
//         roleName: null,
//         allOrganizations: [],
//         primaryOrg: null,
//         hasUniversity: false,
//         hasCompany: false,
//         universityOrgs: [],
//         companyOrgs: []
//       };
//     }

//     const userData = userTypeDetails[0];

//     if (!userData?.organizations || userData.organizations.length === 0) {
//       return { 
//         userType: null, 
//         logo: null, 
//         organizationName: null,
//         roleName: null,
//         allOrganizations: [],
//         primaryOrg: null,
//         hasUniversity: false,
//         hasCompany: false,
//         universityOrgs: [],
//         companyOrgs: []
//       };
//     }

//     // Separate organizations by type
//     const universityOrgs = userData.organizations.filter(org => org.organizationType === 'university');
//     const companyOrgs = userData.organizations.filter(org => org.organizationType === 'company');

//     // Priority: Super Admin > Admin > HR Manager > Faculty > Employee > Alumni > Student
//     const priorityOrder = {
//       'Super Admin': 1,
//       'Admin': 2,
//       'HR Manager': 3,
//       'Faculty': 4,
//       'Employee': 5,
//       'Alumni': 6,
//       'Student': 7
//     };

//     const sortedOrgs = [...userData.organizations].sort((a, b) => {
//       const priorityA = priorityOrder[a.roleName] || 999;
//       const priorityB = priorityOrder[b.roleName] || 999;
//       return priorityA - priorityB;
//     });

//     const primaryOrg = sortedOrgs[0];

//     let userType = null;

//     const roleTypeMap = {
//       'Super Admin': (org) => org.organizationType === 'university' ? 'university' : 'company',
//       'Admin': (org) => org.organizationType === 'university' ? 'university' : 'company',
//       'HR Manager': () => 'university',
//       'Faculty': () => 'university',
//       'Employee': () => 'company',
//       'Alumni': () => 'university',
//       'Student': () => 'university'
//     };

//     if (roleTypeMap[primaryOrg.roleName]) {
//       userType = roleTypeMap[primaryOrg.roleName](primaryOrg);
//     } else {
//       userType = primaryOrg.organizationType;
//     }

//     return {
//       userType: userType,
//       logo: primaryOrg.organizationLogo,
//       organizationName: primaryOrg.organizationName,
//       roleName: primaryOrg.roleName,
//       allOrganizations: userData.organizations,
//       primaryOrg: primaryOrg,
//       hasUniversity: universityOrgs.length > 0,
//       hasCompany: companyOrgs.length > 0,
//       universityOrgs: universityOrgs,
//       companyOrgs: companyOrgs
//     };
//   };

//   const userTypeInfo = getUserTypeAndLogo(userTypeDetails);
//   // console.log('UserTypeInfo:', userTypeInfo);

//   // ============ FUNCTION: Get user type for organization ============
//   const getOrganizationUserType = (org) => {
//     if (org.roleName === 'Super Admin' || org.roleName === 'Admin') {
//       return org.organizationType === 'university' ? 'university' : 'company';
//     } else if (['HR Manager', 'Faculty', 'Alumni', 'Student'].includes(org.roleName)) {
//       return 'university';
//     } else if (org.roleName === 'Employee') {
//       return 'company';
//     }
//     return org.organizationType;
//   };

//   // ============ FUNCTION: Handle organization click navigation ============
//   const handleOrganizationClick = (org) => {
//     const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
//     const userType = getOrganizationUserType(org);
//     console.log('Navigating to:', `${baseUrl}/?userType=${userType}`, 'for org:', org.organizationName);
//     window.open(`${baseUrl}/?userType=${userType}`, '_blank');
//   };

//   // ============ FUNCTION: Get ALL organizations as service items ============
//   const getOrganizationsAsServices = () => {
//     const services = [];

//     // Add all organizations from the response
//     userTypeInfo.allOrganizations.forEach((org, index) => {
//       // Determine the correct icon
//       let icon = org.organizationLogo;
//       let fallbackIcon = org.organizationType === 'company' ? Merchants : university;
      
//       // If logo is null or undefined, use fallback
//       if (!icon) {
//         icon = fallbackIcon;
//       }

//       // Truncate organization name if too long
//       let displayName = org.organizationName || `${org.roleName}`;
//       if (displayName.length > 18) {
//         displayName = displayName.substring(0, 16) + '...';
//       }

//       // Create a unique service item for this organization
//       services.push({
//         icon: icon,
//         name: displayName,
//         fullName: org.organizationName || `${org.roleName}`,
//         roleName: org.roleName,
//         organizationType: org.organizationType,
//         organizationData: org,
//         isDynamic: true,
//         isOrganization: true,
//         fallbackIcon: fallbackIcon,
//         navUserType: getOrganizationUserType(org),
//         // Small icon style
//         iconSize: '28px',
//         fontSize: '8px'
//       });
//     });

//     return services;
//   };

//   // ============ FUNCTION: Get dynamic service names with ALL organizations ============
//   const getProfessionalServicesWithDynamicIcons = () => {
//     // Start with base services that are always shown
//     const baseServices = [
//       { icon: CreateCommunity, name: "Social Ecosystem" },
//       {
//         icon: Certificate,
//         name: "Certification",
//         action: "/learningandcertifiate",
//       },
//       { icon: Brand, name: "Brads" },
//       {
//         icon: ProfessionalService,
//         name: "Professional Service",
//         action: "/myprofile?MainTab=professional_profile",
//       },
//       { icon: AccessManagement, name: "Access Management" },
//       { icon: Subscription, name: "Subscription" },
//       { icon: Event, name: "Events", action: "/professional-events" },
//       { icon: Travel, name: "Travel" },
//       { icon: MemberShip, name: "Membership" },
//       { icon: Discount, name: "Discounts", action: "/discount" },
//     ];

//     // Get all organizations as service items
//     const organizationServices = getOrganizationsAsServices();

//     // Insert organization services at position 4 (after "Professional Service")
//     const insertPosition = 4;
    
//     if (organizationServices.length > 0) {
//       // Remove existing "Company" and "University" entries if they exist
//       const filteredBaseServices = baseServices.filter(
//         item => item.name !== "Company" && item.name !== "University"
//       );
      
//       // Insert organization services
//       filteredBaseServices.splice(insertPosition, 0, ...organizationServices);
//       return filteredBaseServices;
//     }

//     return baseServices;
//   };

//   // ============ FUNCTION: Render organization logo ============
//   const renderOrganizationLogo = () => {
//     if (!userTypeInfo.logo) {
//       return userTypeInfo.userType === 'company' 
//         ? <img src={Merchants} alt="Company" style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'contain' }} />
//         : <img src={university} alt="University" style={{ width: '40px', height: '40px', borderRadius: '8px', objectFit: 'contain' }} />;
//     }

//     return (
//       <img 
//         src={userTypeInfo.logo} 
//         alt={userTypeInfo.organizationName || 'Organization'}
//         style={{ 
//           width: '40px', 
//           height: '40px', 
//           borderRadius: '8px',
//           objectFit: 'contain'
//         }}
//         onError={(e) => {
//           e.target.onerror = null;
//           e.target.src = userTypeInfo.userType === 'company' ? Merchants : university;
//         }}
//       />
//     );
//   };

//   const handleRecruitClick = async () => {
//     if (currentExperiences?.length === 0) {
//       openSnackbar(
//         "You need to be verified and currently employed to visit the posted jobs",
//         "warning"
//       );
//       navigate("/myprofile?mainTab=professional_profile");
//     } else {
//       await dispatch(setSelectedCompany(matchedCompanies[0]?.company_name || {}));
//       await dispatch(getAppliedJobs());
//       await dispatch(getOpenJobs());
//       const res = await dispatch(getJobAnalytics());
//       if (res?.payload?.statusCode == 200) {
//         navigate("/analytics-dashboard");
//       }
//     }
//   };

//   const handleQuickSheduleOpen = () => {
//     const hasWorkExperience = currentExperiences && currentExperiences.length > 0;
//     const hasEducation = currentEducation && currentEducation.length > 0;

//     if (!hasWorkExperience && !hasEducation) {
//       openSnackbar(
//         "You need at least one verified working company or current education to schedule professional events. Please verify your profile to schedule events.",
//         "warning"
//       );
//       navigate("/myprofile?mainTab=professional_profile");
//     } else {
//       setScheduleDrawerOpen(true);
//     }
//   };

//   const handleScheduleClick = () => {
//     setScheduleDrawerOpen(prev => !prev);
//   };

//   const handleClick = (index, type) => {
//     setSelectedService(index);
//     const cardTypes = {
//       personal: personalcardName,
//       professional: professionalcardName,
//       financial: financelcardName,
//     };
//     handleCardClick("dashboard");

//     const selectedCard = cardTypes[type]?.[index] || null;

//     if (selectedCard.name === "Invite") {
//       setOpenInviteProfile(true);
//       return;
//     } else if (selectedCard.name === "Calender") {
//       setOpenCalendar(true);
//       dispatch(getProfessionalEvents());
//       return;
//     } else if (selectedCard.name === "Calendar") {
//       dispatch(getPersonalEvents());
//       dispatch(getConnectedReducer());
//       setOpenPersonalCalendar(true);
//       return;
//     } else if (selectedCard.name === "Scheduler") {
//       setSchedulePersonalOpen(true);
//       return;
//     } else if (selectedCard.name === "Schedule") {
//       handleQuickSheduleOpen();
//       return;
//     } else if (selectedCard.name === "Access") {
//       setOpenAccessModal(true);
//       return;
//     } else if (selectedCard.name == "Events") {
//       dispatch(getPersonalEvents());
//       navigate('/personal-events');
//       return;
//     } else if (selectedCard.name === "Family") {
//       if (Array.isArray(FamilyId) && FamilyId?.length > 0) {
//         navigate(selectedCard.action);
//       } else {
//         setShowModal(true);
//       }
//       return;
//     } else if (selectedCard?.action) {
//       if (selectedCard.name === "Recruit") {
//         handleRecruitClick();
//         return;
//       }
//       dispatch(getJobAnalytics());
//       dispatch(getAppliedJobs());
//       dispatch(getOpenJobs());
//       navigate(selectedCard.action);
//       return;
//     }

//     if (selectedCard) {
//       switch (selectedCard.name) {
//         case "Events":
//           setCurrentModal({ type: "Events", image: Star });
//           break;
//         case "Access":
//           setCurrentModal({ type: "Access", image: Secure });
//           break;
//         case "CIBIL Score":
//           setCurrentModal({ type: "cibil", image: Secure });
//           break;
//         default:
//           setCurrentModal(null);
//       }
//     }
//   };

//   // ============ UPDATED: handlServiceClick with organization handling ============
//   const handlServiceClick = (index, type) => {
//     setSelectedService(index);
//     const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
    
//     // Get the service names based on type
//     let serviceNames;
//     if (type === 'professional') {
//       serviceNames = getProfessionalServicesWithDynamicIcons();
//     } else if (type === 'personal') {
//       serviceNames = personalServiceName;
//     } else if (type === 'financial') {
//       serviceNames = financelServiceName;
//     } else {
//       serviceNames = [];
//     }

//     const selectedServicesCard = serviceNames[index];
//     // console.log('Selected Service:', selectedServicesCard);

//     // Check if this is an organization card
//     if (selectedServicesCard?.isOrganization) {
//       const org = selectedServicesCard.organizationData;
//       if (org) {
//         // console.log('Organization clicked:', org);
//         handleOrganizationClick(org);
//         return;
//       }
//     }

//     // Check for Social Ecosystem
//     if (selectedServicesCard?.name === "Social Ecosystem") {
//       if (type === "personal") {
//         dispatch(setExploreType("PERSONAL"));
//         navigate("/community");
//         return;
//       } else if (type === "professional") {
//         const hasVerifiedEducation = ProfessionalEducation?.some(
//           edu => edu.is_verified === true
//         );
//         const hasVerifiedCurrentWork = currentExperiences?.length > 0;

//         if (hasVerifiedEducation || hasVerifiedCurrentWork) {
//           dispatch(setExploreType("PROFESSIONAL"));
//           navigate("/community");
//         } else {
//           openSnackbar(
//             "Verify at least one education or company to access the professional community.",
//             "warning"
//           );
//         }
//         return;
//       }
//     }

//     // Handle navigation for actions
//     if (selectedServicesCard?.action) {
//       navigate(selectedServicesCard?.action);
//       return;
//     }

//     // Handle other service clicks
//     if (selectedServicesCard) {
//       switch (selectedServicesCard.name) {
//         case "Payments":
//           setCurrentModal({ type: "Payments", image: Star });
//           break;
//         case "Beauty Grooming":
//           setCurrentModal({ type: "Beauty Grooming", image: Star });
//           break;
//         case "Create Community":
//           setCurrentModal({ type: "Create Community", image: Star });
//           break;
//         case "Life cycle":
//           setCurrentModal({ type: "Life style", image: Star });
//           break;
//         case "Access Management":
//           setCurrentModal({ type: "Access Management", image: Secure });
//           break;
//         case "SKU & Offers":
//           setCurrentModal({ type: "SKU & Offers", image: Star });
//           break;
//         case "Subscription":
//           setCurrentModal({ type: "Subscription", image: Star });
//           break;
//         case "Birth Chart":
//           setCurrentModal({ type: "Birth Chart", image: Star });
//           break;
//         case "Travel":
//           setCurrentModal({ type: "Travel", image: Star });
//           break;
//         case "Membership":
//           setCurrentModal({ type: "Membership", image: Star });
//           break;
//         case "Personality Test":
//           dispatch(getPersonalityTestResult());
//           navigate("/personalitytest");
//           break;
//         case "Brands":
//           setCurrentModal({ type: "Brands", image: Star });
//           break;
//         case "Company":
//           if (userTypeInfo.userType === 'company') {
//             window.open(`${baseUrl}/?userType=company`, '_blank');
//           } else if (userTypeInfo.userType === 'university') {
//             window.open(`${baseUrl}/?userType=university`, '_blank');
//           } else {
//             if (userTypeInfo.allOrganizations && userTypeInfo.allOrganizations.length > 1) {
//               setShowOrganizationSelector(true);
//             } else {
//               window.open(`${baseUrl}/`, '_blank');
//             }
//           }
//           break;
//         case "University":
//           if (userTypeInfo.userType === 'university') {
//             window.open(`${baseUrl}/?userType=university`, '_blank');
//           } else if (userTypeInfo.userType === 'company') {
//             window.open(`${baseUrl}/?userType=company`, '_blank');
//           } else {
//             if (userTypeInfo.allOrganizations && userTypeInfo.allOrganizations.length > 1) {
//               setShowOrganizationSelector(true);
//             } else {
//               window.open(`${baseUrl}/`, '_blank');
//             }
//           }
//           break;
//         case "Events":
//           dispatch(getProfessionalEvents());
//           navigate('/professional-events');
//           break;
//         case "Discounts":
//           setCurrentModal({ type: "Discounts", image: Star });
//           break;
//         default:
//           setCurrentModal(null);
//       }
//     }
//   };

//   const [showOrganizationSelector, setShowOrganizationSelector] = useState(false);

//   const personalcardName = [
//     { icon: Access, name: "Access" },
//     { icon: Event, name: "Events", action: "/personal-events" },
//     { icon: Calender, name: "Calendar" },
//     { icon: Schedule, name: "Scheduler" },
//     { icon: Notes, name: "Notes", action: "/notes" },
//     { icon: GroupsIcon, name: "Group", action: "/AllGroup_details" },
//     { icon: Family, name: "Family", action: `/familyCard/${FamilyId?.[0]}` },
//     { icon: Family, name: "CCE", action: `/connect-chat` },
//   ];

//   const professionalcardName = [
//     { icon: Vcard, name: "V Card", action: "/AllBusinessCard" },
//     { icon: Access, name: "Access" },
//     { icon: Calender, name: "Calender" },
//     { icon: Schedule, name: "Schedule" },
//     { icon: Notes, name: "Notes", action: "/notes" },
//     { icon: Invite, name: "Invite" },
//     { icon: Jobs, name: "Jobs", action: "/jobopening" },
//     { icon: Recruit, name: "Recruit", action: "/analytics-dashboard" },
//   ];

//   const financelcardName = [
//     { icon: Payment, name: "Scan & Pay" },
//     { icon: TapGo, name: "Tap & Go" },
//     { icon: Bill, name: "Bills" },
//     { icon: Event, name: "Events" },
//     { icon: KYC, name: "KYC", action: "/countrySelecting" },
//     { icon: CIBIL, name: "CIBIL Score" },
//     { icon: Manage, name: "Manage" },
//     { icon: Reward, name: "Reward" },
//   ];

//   const personalServiceName = [
//     { icon: CreateCommunity, name: "Social Ecosystem", action: "/community" },
//     { icon: PersonalService, name: "Personality Test", action: "/personalitytest" },
//     { icon: BirthChart, name: "Birth Chart" },
//     { icon: LiftStyle, name: "Life Style", action: "/product-marketplace" },
//     { icon: BeautyGroom, name: "Beauty Grooming" },
//     { icon: Discount, name: "Discounts", action: "/discount" },
//     { icon: Sku, name: "SKU & Offers" },
//     { icon: Travel, name: "Travel" },
//     { icon: Subscription, name: "Subscription" },
//     { icon: Payment, name: "Payments" },
//     { icon: AccessManagement, name: "Access Management" },
//     { icon: MemberShip, name: "Membership" },
//   ];

//   // Base professional services (without organization items)
//   const professionalServiceName = [
//     { icon: CreateCommunity, name: "Social Ecosystem" },
//     {
//       icon: Certificate,
//       name: "Certification",
//       action: "/learningandcertifiate",
//     },
//     { icon: Brand, name: "Brads" },
//     {
//       icon: ProfessionalService,
//       name: "Professional Service",
//       action: "/myprofile?MainTab=professional_profile",
//     },
//     { icon: AccessManagement, name: "Access Management" },
//     { icon: Subscription, name: "Subscription" },
//     { icon: Event, name: "Events", action: "/professional-events" },
//     { icon: Travel, name: "Travel" },
//     { icon: MemberShip, name: "Membership" },
//     { icon: Discount, name: "Discounts", action: "/discount" },
//   ];

//   const financelServiceName = [
//     { icon: Account, name: "Accounts" },
//     { icon: Loans, name: "Loans" },
//     { icon: Insurance, name: "Insurance" },
//     { icon: CreditCard, name: "Credit Card" },
//     { icon: FD, name: "FD" },
//     { icon: MutualFund, name: "Mutual Funds" },
//     { icon: RD, name: "RD" },
//     { icon: PreApproved, name: "Pre-approved Loans" },
//     { icon: Paylater, name: "Pay Later" },
//     { icon: GiftCard, name: "Gift Cards" },
//     { icon: Advisory, name: "Advisory" },
//     { icon: TravelCard, name: "Travel Card" },
//   ];

//   const financialoffers = [
//     { image: BankOffer1, alt: "Bank Offer 1" },
//     { image: BankOffer2, alt: "Bank Offer 2" },
//     { image: BankOffer3, alt: "Bank Offer 3" },
//   ];

//   const personaloffers = [{ image: ServiceImg, alt: "offers" }];

//   return (
//     <>
//       <NoOfCards />
      
//       {activeMenu === "personal_profile" ? (
//         <ToolsSection
//           showAll={personalshowAll}
//           toggleView={() => setPersonalShowAll(!personalshowAll)}
//           cardData={personalcardName}
//           handleCardClick={handleClick}
//           type={"personal"}
//         />
//       ) : activeMenu === "professional_profile" ? (
//         <ToolsSection
//           showAll={professionashowAll}
//           toggleView={() => setProfessionalShowAll(!professionashowAll)}
//           cardData={professionalcardName}
//           handleCardClick={handleClick}
//           type={"professional"}
//         />
//       ) : activeMenu === "financel" ? (
//         <ToolsSection
//           showAll={financelshowAll}
//           toggleView={() => setFinancelShowAll(!financelshowAll)}
//           cardData={financelcardName}
//           handleCardClick={handleClick}
//           type={"financial"}
//         />
//       ) : null}

//       {activeMenu === "personal_profile" ? (
//         <ServiceSection
//           serviceNames={personalServiceName}
//           showAll={personalshowAllService}
//           toggleView={() => setPersonalShowAllService(!personalshowAllService)}
//           handleClick={handlServiceClick}
//           type={"personal"}
//         />
//       ) : activeMenu === "professional_profile" ? (
//         <ServiceSection
//           serviceNames={getProfessionalServicesWithDynamicIcons()}
//           showAll={professionalshowAllService}
//           toggleView={() => setProfessionalShowAllService(!professionalshowAllService)}
//           handleClick={handlServiceClick}
//           type={"professional"}
//         />
//       ) : activeMenu === "financel" ? (
//         <ServiceSection
//           serviceNames={financelServiceName}
//           showAll={financialshowAllService}
//           toggleView={() => setFinancialShowAllService(!financialshowAllService)}
//           handleClick={handlServiceClick}
//           type={"financial"}
//         />
//       ) : null}

//       {activeMenu === "financel" ? (
//         <OffersSection offers={financialoffers} />
//       ) : (
//         <OffersSection offers={personaloffers} />
//       )}

//       <div
//         className="home-sec-middlePart p-2 "
//         style={{
//           scrollbarWidth: "none",
//         }}
//       >
//         {latitude !== null &&
//           latitude !== "" &&
//           longitude !== null &&
//           longitude !== "" && (
//             <div
//               style={{
//                 width: "420px",
//                 height: "300px",
//                 minWidth: "380px",
//                 maxWidth: "420px",
//               }}
//             >
//               <MapIntegration
//                 style={{ borderRadius: "6px" }}
//                 latitude={latitude}
//                 longitude={longitude}
//               />
//             </div>
//           )}

//         {/* ============ Display Organization Logo Section ============ */}
//         {userTypeInfo.logo && userTypeInfo.organizationName && (
//           <div style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: '12px',
//             padding: '12px 16px',
//             background: '#f8f9fa',
//             borderRadius: '8px',
//             marginBottom: '16px',
//             border: '1px solid #e9ecef'
//           }}>
//             {renderOrganizationLogo()}
//             <div style={{ display: 'flex', flexDirection: 'column' }}>
//               <span style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
//                 {userTypeInfo.organizationName}
//               </span>
//               <span style={{ fontSize: '12px', color: '#666' }}>
//                 {userTypeInfo.roleName} • {userTypeInfo.userType === 'company' ? '🏢 Company' : '🎓 University'}
//               </span>
//             </div>
//           </div>
//         )}

//         <Drawer
//           anchor="right"
//           open={openCalendar}
//           onClose={() => {
//             setOpenCalendar(false);
//             setSelectedEvent(null);
//           }}
//           classes={{
//             paper: {
//               width: "90vw",
//               maxWidth: "50vw",
//             },
//           }}
//         >
//           <Box
//             sx={{
//               height: "100vh",
//               display: "flex",
//               flexDirection: "column",
//               p: "20px",
//             }}
//           >
//             <Box
//               display="flex"
//               justifyContent="flex-start"
//               mb={2}
//               sx={{ width: "100%" }}
//             >
//               <IconButton onClick={() => setOpenCalendar(false)}>
//                 <CloseRoundedIcon />
//               </IconButton>
//             </Box>
//             <Box sx={{ flex: 1, overflow: "hidden", padding: "20px" }}>
//               <ProfessionalCalender initialView="month" />
//             </Box>
//           </Box>
//         </Drawer>

//         <Drawer
//           anchor="right"
//           open={openPersonalCalendar}
//           onClose={() => {
//             setOpenPersonalCalendar(false);
//             setSelectedEvent(null);
//           }}
//           classes={{
//             paper: {
//               width: "90vw",
//               maxWidth: "50vw",
//             },
//           }}
//         >
//           <Box
//             sx={{
//               height: "100vh",
//               display: "flex",
//               flexDirection: "column",
//               p: "20px",
//             }}
//           >
//             <Box
//               display="flex"
//               justifyContent="flex-start"
//               mb={2}
//               sx={{ width: "100%" }}
//             >
//               <IconButton onClick={() => setOpenPersonalCalendar(false)}>
//                 <CloseRoundedIcon />
//               </IconButton>
//             </Box>
//             <Box sx={{ flex: 1, overflow: "hidden", padding: "20px" }}>
//               <PersonalCalender />
//             </Box>
//           </Box>
//         </Drawer>

//         <Modal
//           open={Boolean(CompanyModal)}
//           onClose={() => setCompanyModal(false)}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Box
//             style={{
//               backgroundColor: "white",
//               borderRadius: "12px",
//               padding: "32px",
//               maxWidth: "450px",
//               width: "90%",
//               boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
//               outline: "none",
//               position: "relative",
//             }}
//           >
//             <IconButton
//               onClick={() => setCompanyModal(false)}
//               style={{
//                 position: "absolute",
//                 top: "12px",
//                 right: "12px",
//                 color: "#666"
//               }}
//             >
//               <CloseRoundedIcon />
//             </IconButton>

//             <Box style={{ textAlign: "center", padding: "16px 0" }}>
//               <Typography variant="h6" style={{
//                 fontWeight: 600,
//                 color: "#333",
//                 marginBottom: "16px"
//               }}>
//                 Create Your Company
//               </Typography>
//               <Typography variant="body2" style={{
//                 color: "#666",
//                 marginBottom: "24px",
//                 lineHeight: 1.5
//               }}>
//                 To access company features, you need to create or register your company first
//               </Typography>

//               <Box style={{
//                 display: "flex",
//                 gap: "16px",
//                 justifyContent: "center",
//                 marginTop: "32px"
//               }}>
//                 <Button
//                   variant="outlined"
//                   onClick={() => setCompanyModal(false)}
//                   style={{
//                     borderColor: "#ddd",
//                     color: "#666",
//                     textTransform: "none",
//                     padding: "8px 24px"
//                   }}
//                 >
//                   Maybe Later
//                 </Button>
//                 <Button
//                   variant="contained"
//                   onClick={() => {
//                     const baseUrl = process.env.REACT_APP_ENTERPRISE_URL;
//                     setCompanyModal(false);
//                     window.location.replace(`${baseUrl}`);
//                   }}
//                   style={{
//                     backgroundColor: "#0044C6",
//                     color: "white",
//                     textTransform: "none",
//                     borderRadius: "5px",
//                     padding: "8px 32px"
//                   }}
//                 >
//                   Create Company
//                 </Button>
//               </Box>
//             </Box>
//           </Box>
//         </Modal>

//         <Modal
//           open={Boolean(currentModal)}
//           onClose={() => setCurrentModal(null)}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Box
//             sx={{
//               backgroundColor: "background.paper",
//               borderRadius: 2,
//               p: 2,
//               maxWidth: "90vw",
//               maxHeight: "90vh",
//               overflow: "auto",
//               outline: "none",
//               position: "relative",
//             }}
//           >
//             {currentModal && (
//               <ComingSoon
//                 imageSrc={currentModal?.image}
//                 onClose={() => setCurrentModal(null)}
//               />
//             )}
//           </Box>
//         </Modal>

//         <Modal
//           open={showOrganizationSelector}
//           onClose={() => setShowOrganizationSelector(false)}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Box
//             sx={{
//               backgroundColor: "white",
//               borderRadius: "12px",
//               padding: "24px",
//               maxWidth: "500px",
//               width: "90%",
//               maxHeight: "80vh",
//               overflow: "auto",
//               outline: "none",
//             }}
//           >
//             <Typography variant="h6" style={{ marginBottom: '16px', fontWeight: 600 }}>
//               Select Organization
//             </Typography>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//               {userTypeInfo.allOrganizations?.map((org, idx) => (
//                 <div
//                   key={idx}
//                   onClick={() => {
//                     handleOrganizationClick(org);
//                     setShowOrganizationSelector(false);
//                   }}
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '12px',
//                     padding: '12px 16px',
//                     cursor: 'pointer',
//                     borderRadius: '8px',
//                     border: '1px solid #e9ecef',
//                     transition: 'background 0.2s',
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.background = '#f8f9fa'}
//                   onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                 >
//                   {org.organizationLogo ? (
//                     <img 
//                       src={org.organizationLogo} 
//                       alt={org.organizationName}
//                       style={{ width: '40px', height: '40px', borderRadius: '6px', objectFit: 'contain' }}
//                     />
//                   ) : (
//                     <div style={{ 
//                       width: '40px', 
//                       height: '40px', 
//                       borderRadius: '6px',
//                       background: org.organizationType === 'company' ? '#e3f2fd' : '#f3e5f5',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       fontSize: '16px',
//                       fontWeight: 'bold',
//                       color: org.organizationType === 'company' ? '#1976d2' : '#7b1fa2'
//                     }}>
//                       {org.organizationName?.charAt(0) || org.roleName?.charAt(0) || '?'}
//                     </div>
//                   )}
//                   <div style={{ flex: 1 }}>
//                     <div style={{ fontWeight: 500, fontSize: '14px' }}>
//                       {org.organizationName || 'Unnamed Organization'}
//                     </div>
//                     <div style={{ fontSize: '12px', color: '#666', display: 'flex', gap: '8px', alignItems: 'center' }}>
//                       <span style={{ 
//                         color: org.organizationType === 'company' ? '#1976d2' : '#7b1fa2',
//                         fontWeight: 500
//                       }}>
//                         {org.roleName}
//                       </span>
//                       <span style={{ color: '#999' }}>
//                         {org.organizationType === 'university' ? '🎓' : '💼'}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <Button 
//               onClick={() => setShowOrganizationSelector(false)}
//               style={{ marginTop: '16px', width: '100%' }}
//             >
//               Cancel
//             </Button>
//           </Box>
//         </Modal>

//         {showModal && (
//           <div className="lightbox-overlay">
//             <div className="lightbox-content p-4">
//               <div className="d-flex align-items-center justify-content-between">
//                 <h6
//                   className="mb-0"
//                   style={{
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                     color: "black",
//                   }}
//                 >
//                   Family card
//                 </h6>
//                 <IconButton onClick={() => setShowModal(false)}>
//                   <CloseRoundedIcon />
//                 </IconButton>
//               </div>
//               <Typography variant="body2" className="text-muted">
//                 You haven't created your Family Card yet. Please create your
//                 Family Card to view it here.
//               </Typography>
//             </div>
//           </div>
//         )}

//         <InviteProfile
//           open={openInviteProfile}
//           setModalOpen={setOpenInviteProfile}
//           handleSuccess={handleSuccess}
//           handleFailure={handleFailure}
//         />

//         <ProfessionalShedule
//           open={scheduleDrawerOpen}
//           onClose={() => {
//             setScheduleDrawerOpen(false);
//           }}
//         />

//         <ScheduleEvent
//           open={scheduleDrawerOpen}
//           onClose={() => {
//             setScheduleDrawerOpen(false);
//           }}
//         />

//         <SchedulePersonalEvent
//           open={schedulePersonalOpen}
//           onClose={() => {
//             setSchedulePersonalOpen(false);
//             dispatch(getPersonalEvents());
//           }}
//         />
//       </div>
//     </>
//   );
// };

// export default HomepageMiddleFeed;
